import * as React from 'react';
import { IFullPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IFullPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export class PagingArrows extends React.Component<IPagingArrowsProps, any> {
    render() {
        if (!this.props.paging.totalItems || this.props.paging.totalItems === 0) return null;

        const numberOfPages = this.props.paging.totalPages;

        if (this.props.isLeftArrows) {
            const isDisabled = this.props.paging.pageNumber === 1;
            return (
                <>
                    {isDisabled
                        ?
                        <button disabled={true} className="btn-arrow-left btn-icon">
                            &nbsp;<span className="visually-hidden" dangerouslySetInnerHTML={{ __html: "Previous" }} />
                        </button>
                        :
                        <button type="button" className="btn-arrow-left btn-icon" onClick={() => this.props.onPageSelect(this.props.paging.pageNumber - 1)}>
                            &nbsp;<span className="visually-hidden" dangerouslySetInnerHTML={{ __html: "Previous" }} />
                        </button>
                    }
                </>
            );
        }
        else {
            const isDisabled = this.props.paging.pageNumber === numberOfPages;
            return (
                <>
                    {isDisabled
                        ?
                        <button disabled={true} className="btn-arrow-right btn-icon">
                            &nbsp;<span className="visually-hidden" dangerouslySetInnerHTML={{ __html: "Next" }} />
                        </button>
                        :
                        <button type="button" className="btn-arrow-right btn-icon" onClick={() => this.props.onPageSelect(this.props.paging.pageNumber + 1)}>
                            &nbsp;<span className="visually-hidden" dangerouslySetInnerHTML={{ __html: "Next" }} />
                        </button>
                    }
                </>
            );
        }
    }
}